<div class="asset-tagging-n-taxonomy-container">
  <div class="header rounded-lg flex flex-row items-center sticky top-0 asset-details p-4 z-50">
    <h2 class="asset-details-title title font-bold text-xl" i18n>Tags</h2>
    <div class="actions text-right">
      <button *ngIf="editFlag" class="save-button pl-4 cursor-pointer" mat-icon-button i18n-matTooltip matTooltip="Save" (click)="saveAssetInfo()" [disabled]="saveProcess || customFormInvalidCheck">
        <mat-icon class="material-icons-outlined">save</mat-icon>
      </button>
      <button *ngIf="editFlag" class="pl-4 cursor-pointer" mat-icon-button i18n-matTooltip matTooltip="Close" (click)="editInformation()">
        <mat-icon class="material-icons-outlined">close</mat-icon>
      </button>
      <ng-container *thehubzCanRole="{ role: ['tagging'], accessType: 'AccessAsset', assetInfo: assetInfo }">
        <div *ngIf="![CustomClients.Standard, CustomClients.VKB, CustomClients.LufthansaMedialounge].includes(brandingKey) && !editFlag">
          <button class="cursor-pointer !inline-flex" mat-icon-button i18n-matTooltip matTooltip="Edit asset tags" (click)="editInformation()">
            <mat-icon class="material-icons-outlined">edit</mat-icon>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="details px-4">
    <div class="detail-header" [ngClass]="{ 'detail-header-mobile': screenSizeDetectorService.isSmallScreen }">
      <form class="asset-info-form" [formGroup]="updateAssetForm" *ngIf="editFlag">
        <div class="dataset-entry input-box">
          <span class="dataset-entry-label field-label" i18n>Tags</span>
          <div class="dataset-entry-value field-value">
            <sp-chips-grid-row
              formControlName="tags"
              aria-label="Tags"
              [autoCompSource]="autoCompTags"
              [dataSource]="tags"
              [placeholder]="tagPlaceHolderText"
              [chipInputTooltip]="chipInputTooltipText"
              (removeChip)="removeTag($event)"
              (matChipInputToken)="add($event)"
            ></sp-chips-grid-row>
          </div>
        </div>
      </form>
      <div *ngIf="!editFlag && assetInfo['tags'] && assetInfo['tags'].length" class="dataset-entry pb-1">
        <span class="dataset-entry-label w-2/5 field-label inline-block" *ngIf="[CustomClients.VKB, CustomClients.Vorwerk].includes(brandingKey)">Tags</span>
        <p class="dataset-entry-value field-value inline-block pl-2 w-3/5" [ngClass]="{ '!w-full': ![CustomClients.VKB, CustomClients.Vorwerk].includes(brandingKey) }">
          <sp-loading-inprogress *ngIf="tagHttpCallInProgress; else loadingComplete" [showSpinner]="true" [diameter]="50"></sp-loading-inprogress>
          <ng-template #loadingComplete>
            <sp-chips-listbox-option [dataSource]="updateAssetForm.controls['tags'].value" [chipViewMode]="'view'" (selectedChips)="clickOnChip($event)"></sp-chips-listbox-option>
          </ng-template>
        </p>
      </div>
    </div>
    <div class="mt-4">
      <thehubz-custom-asset-fields #cusFieldsTest [tabType]="'tagging'" [assetInfo]="assetInfo"></thehubz-custom-asset-fields>
    </div>
  </div>
</div>
<thehubz-asset-notifications [asset]="assetInfo" *ngIf="!editFlag"></thehubz-asset-notifications>
